import { Injectable } from "@angular/core";
import { StorageService } from "./storage.services";
import { User } from "../model";
import { jwtDecode } from "jwt-decode";
import { e } from "@angular/cdk/scrolling-module.d-aa3aedaa";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class UserSettingsService {
  user?: User;

  constructor(private readonly _storage: StorageService,private readonly router:Router) {}

  /**
   *
   * @param user
   * @param storageReady usado para indicar que el usuario ya esta en el local storage,
   * por lo que no es necesario guardarlo nuevamente.
   */
  setUser(token, storageReady?) {
    if (!token) {
      this.user = null;
      return;
    }
    
    const tokenDecode =  jwtDecode(token);
    const user:User = {
      id : tokenDecode["id"],
      email : tokenDecode["email"],
      firstName : tokenDecode["first_name"],
      lastName : tokenDecode["last_name"],
      userFullName : tokenDecode["user_full_name"],
      role : tokenDecode["role"],
      roleName : tokenDecode["role_name"],
      currentLoggedOrganization : tokenDecode["current_logged_organization"],
      organizations : tokenDecode["organizations"],
      loginDate : new Date().toString(),
      access : tokenDecode["access"],
    }
    this.user = user;

   this._storage.guardar_storage("User", user);
   localStorage.setItem("token", token);
  }

  logOut() {
    this.setUser(null);
    this._storage.deleteItemFromStorage("User");
    this._storage.deleteItemFromStorage("token");
    this.router.navigate(["/login"]);
  }

   getUser() {
    const user = localStorage.getItem("User");
    const userObject = JSON.parse(user);
    
    const userModel:User = {
      id : userObject["id"],
      email : userObject["email"],
      firstName : userObject["firstName"],
      lastName : userObject["lastName"],
      userFullName : userObject["userFullName"],
      currentLoggedOrganization : userObject["currentLoggedOrganization"],
      organizations : userObject["organizations"],
      access : userObject["access"],
    }
    return userModel;
  }

  loadUser() {
    this._storage
      .cargar_storage("User")
      .then((result) => {
        // Cargamos el usaurio en memoria
        this.setUser(result, true);
      })
      .catch((err) => {
        console.log({ err });
      });
  }

  setToken(token) {
    this.user.token = token;
  }

  getToken(): string {
    return localStorage.getItem("token") ?? '';
  }

  userLoaded(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (this.user && this.user.token) {
        resolve(true);
      } else {
        console.log("Loading user");
        this._storage
          .cargar_storage("User")
          .then((result) => {
            if (
              result &&
              result["token"] &&
              result["loginDate"] &&
              result["email"]
            ) {
              console.log("User loaded from storage");
              console.log(result);
              this.setUser(result, true);
              resolve(true);
            } else {
              this.logOut();
              resolve(false);
            }
            resolve(true);
          })
          .catch((err) => {
            console.log({ err });

            resolve(false);
          });
      }
    });
  }

  validateToken(){
    const token = this.getToken();
    if(token){
      const tokenValid = jwtDecode(token);
      const now = Math.floor(Date.now() / 1000); 

       return tokenValid.exp > now
    }
  }

  rememberUserEmail(email:string){
  localStorage.setItem("loginEmail",email);
  }
  removeUserEmail(){
  localStorage.removeItem("loginEmail");
  }
  getUserEmail(){
  return localStorage.getItem("loginEmail");
  }

}
